// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__AIly2","row":"styles_row__8GoUc","wrap_inner":"styles_wrap_inner__ywCP1","table_row":"styles_table_row__4oZWw","table_col":"styles_table_col__C6yEs"};